// The model document's PRIMARY voxel grid — the one the editing tools mutate,
// history snapshots, and the mesher renders. Owned here (core/edit-core) so any
// slice can import it directly instead of receiving it through main's wiring.
// (Scratch/secondary grids — e.g. pick fallbacks, baked clones — are NOT this;
// they stay local to their owners.)
//
// Mutation rules are unchanged: wrap grid edits in beginTransaction /
// endTransaction (model/history) so they land on the document's single undo
// timeline. See CLAUDE.md "Undo".

import { VoxelGrid } from "../../model/voxel-grid";

export const grid = new VoxelGrid();
